import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  class CountdownTimer {
    constructor(el) {
      const time = new Date($(el).data('endtime'));
      // add one sec to compensate delay
      time.setSeconds(time.getSeconds() + 1);
      this.endtime = Date.parse(time);
      this.initializeClock();
    }

    initializeClock() {
      const $timerEl = $('.countdown-timer');
      const $dayEl = $timerEl.find('.countdown-timer__time--day');
      const $hrEl = $timerEl.find('.countdown-timer__time--hr');
      const $minEl = $timerEl.find('.countdown-timer__time--min');
      const $secEl = $timerEl.find('.countdown-timer__time--sec');

      const updateClock = () => {
        const t = this.getTimeRemaining();
        if (t.total <= 0) {
          clearInterval(timeinterval);
          $('.upgrade-band, .countdown-timer').remove();
          return;
        }

        $dayEl.text(this.getPadded(t.days));
        $hrEl.text(this.getPadded(t.hours));
        $minEl.text(this.getPadded(t.minutes));
        $secEl.text(this.getPadded(t.seconds));
      };
      updateClock();
      const timeinterval = setInterval(updateClock, 1000);
    }

    getTimeRemaining() {
      const total = this.endtime - Date.parse(new Date());
      const seconds = Math.floor((total / 1000) % 60);
      const minutes = Math.floor((total / 1000 / 60) % 60);
      const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
      const days = Math.floor(total / (1000 * 60 * 60 * 24));
      return {
        total,
        days,
        hours,
        minutes,
        seconds,
      };
    }

    getPadded(n) {
      return ('0' + n).slice(-2);
    }
  }

  // initialize timer
  if ($('.countdown-timer').length) {
    new CountdownTimer($('.countdown-timer'));
  }
});
